/**
 * 从 window 全局变量中获取数据
 * @param key 属性
 */
export const getWindowData = (key) => {
    try {
        return window[key];
    }
    catch { }
    return null;
};
